var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBunny2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 140,
    viewBox: "0 0 144 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 72,
    cy: 128,
    rx: 72,
    ry: 12,
    fill: "#4D4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2702 89.4122C30.5702 87.2122 25.7702 117.312 28.5702 128.512C35.4702 128.712 52.8702 128.512 52.8702 128.512L72.5702 124.012C72.5702 124.012 72.9702 120.812 73.3702 115.912C71.2702 111.512 40.4702 91.0122 36.2702 89.4122Z",
    fill: "url(#paint0_linear_3674_7706)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.47 48.9122C34.57 51.6122 20.87 60.5122 19.67 82.0122C18.47 103.512 22.27 113.212 21.27 123.312C20.57 129.512 21.57 131.612 24.17 131.412C26.77 131.212 30.97 127.412 31.47 120.112C31.97 112.812 31.27 103.512 32.07 99.1122C32.77 94.7122 51.77 64.1122 43.47 48.9122Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9701 114.212C38.8701 109.212 44.1701 106.712 47.2701 101.012C49.2701 67.0122 89.1701 71.1122 89.3701 71.0122C93.6701 74.1122 102.77 83.4122 107.17 96.4122C111.57 109.412 109.27 117.412 106.27 122.812C103.37 128.212 99.3701 129.212 96.2701 129.912C93.1701 130.612 80.4701 130.912 74.2701 131.112C68.0701 131.312 54.8701 131.612 52.9701 131.512C51.0701 131.412 50.7701 129.912 51.9701 127.412C53.7701 124.612 55.6701 123.312 69.7701 122.812C65.5701 118.512 61.9701 112.812 61.0701 109.812C59.9701 111.112 58.7701 112.112 57.5701 113.012C51.1701 117.612 44.4701 121.412 41.9701 126.512C39.5701 131.712 37.8701 133.012 35.7701 132.712C33.5701 132.412 33.0701 129.812 32.9701 127.112C32.9701 125.812 32.5701 120.112 35.9701 114.212Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1698 52.0122C32.4698 54.8122 26.1698 63.5122 24.4698 74.7122C22.7698 86.0122 27.8698 95.5122 36.5698 101.812C47.9698 101.512 56.1698 97.9122 60.9698 92.5122C65.7698 87.1122 67.7698 79.7122 65.9698 74.8122C63.9698 69.9122 43.1698 52.0122 43.1698 52.0122Z",
    fill: "url(#paint1_linear_3674_7706)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.67 109.012C116.47 104.312 122.67 108.712 125.37 112.312C127.27 114.712 127.37 117.112 129.57 118.612C131.77 120.112 131.97 120.412 130.57 122.712C129.17 125.112 125.47 129.412 118.67 130.512C111.87 131.612 107.47 128.912 105.17 124.712L109.67 109.012Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.67 12.0122C16.67 13.0122 26.87 17.6122 37.47 21.8122C48.07 26.0122 57.97 27.3122 65.97 28.7122C66.77 28.8122 68.27 29.2122 69.27 29.4122C74.77 30.9122 82.77 33.7122 87.37 41.8122C90.77 48.0122 89.37 50.8122 89.57 55.5122C89.77 60.3122 90.37 65.8122 89.67 69.5122C88.97 73.2122 87.67 77.7122 81.47 77.4122C75.27 77.2122 72.67 75.0122 66.77 74.8122C60.27 73.9122 55.77 73.4122 48.67 66.2122C45.47 63.0122 36.57 46.8122 51.27 38.7122C51.27 38.7122 51.37 37.3122 49.27 37.0122C47.17 36.8122 45.67 38.4122 42.37 39.5122C39.07 40.6122 32.67 41.7122 25.67 36.5122C18.57 31.3122 9.77002 23.3122 7.17002 14.1122C6.77002 12.1122 6.67002 11.0122 11.67 12.0122Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8701 75.0122C72.8701 75.2122 75.3701 77.3122 81.5701 77.6122C81.7701 77.6122 81.8701 77.6122 82.0701 77.6122C87.0701 77.6122 88.6701 74.3122 89.4701 71.1122L89.9701 71.5122C89.2701 74.4122 87.5701 78.2122 82.0701 78.2122C81.8701 78.2122 81.7701 78.2122 81.5701 78.2122C78.3701 78.1122 76.1701 77.5122 73.9701 76.9122C71.7701 76.3122 69.7701 75.8122 66.8701 75.7122C66.8701 75.7122 66.1701 75.6122 66.0701 75.6122L65.8701 75.0122C66.1701 74.9122 66.4701 75.0122 66.8701 75.0122Z",
    fill: "url(#paint2_linear_3674_7706)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5699 0.712218C26.9699 -2.28778 44.4699 4.81222 50.8699 10.4122C57.2699 16.0122 62.1699 21.4122 69.2699 29.5122C69.2699 29.5122 44.5699 25.6122 37.8699 22.0122C30.8699 15.8122 25.9699 9.41222 23.5699 3.41222C23.5699 3.41222 22.7699 1.71222 23.5699 0.712218Z",
    fill: "url(#paint3_linear_3674_7706)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9699 37.2122C44.5699 36.9122 46.0699 35.1122 50.1699 34.9122C46.5699 34.5122 43.8699 33.6122 40.2699 32.1122C34.9699 29.9122 27.8699 25.1122 22.4699 21.9122C17.0699 18.7122 13.1699 16.7122 12.2699 17.7122C11.4699 18.4122 13.2699 20.8122 13.2699 20.8122C17.4699 26.0122 26.6699 37.8122 38.9699 37.2122Z",
    fill: "#F22E6C",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5701 57.1122C74.5701 57.3122 74.0701 62.1122 71.7701 61.9122C69.4701 61.7122 70.5701 56.9122 72.5701 57.1122Z",
    fill: "#4D4D4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7701 69.3122C89.4701 69.3122 89.1701 69.4122 88.9701 69.6122L87.5701 71.2122L85.7701 68.8122C85.4701 68.4122 84.8701 68.3122 84.4701 68.6122C84.0701 68.9122 83.9701 69.5122 84.2701 69.9122L86.7701 73.2122C86.9701 73.4122 87.1701 73.6122 87.4701 73.6122C87.7701 73.6122 87.9701 73.5122 88.1701 73.3122L88.9701 72.4122C89.2701 71.5122 89.4701 70.6122 89.6701 69.7122C89.7701 69.5122 89.7701 69.4122 89.7701 69.3122Z",
    fill: "#4D4D4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.77 97.5122C32.37 99.2122 34.17 100.912 36.17 102.312L36.37 102.412H36.57C40.47 102.312 44.17 101.812 47.37 101.012L47.47 100.412C44.27 101.312 40.57 101.812 36.57 101.912C34.47 100.412 32.67 98.7122 31.07 96.9122L30.77 97.5122Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3674_7706",
    x1: 50.5594,
    y1: 89.2977,
    x2: 50.5594,
    y2: 128.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3674_7706",
    x1: 45.3839,
    y1: 52.0122,
    x2: 45.3839,
    y2: 101.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3674_7706",
    x1: 77.9201,
    y1: 71.1122,
    x2: 77.9201,
    y2: 78.2122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3674_7706",
    x1: 46.2421,
    y1: 0,
    x2: 46.2421,
    y2: 29.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBunny2);
export default __webpack_public_path__ + "static/media/bunny-2.9b784db7d80fa878d7b37d0d1df6f6b0.svg";
export { ForwardRef as ReactComponent };